import React from 'react';
import { FiSend } from 'react-icons/fi';
import Toggle from '../../../Toggle';
import TemplateCard from './TemplateCard';
import { TabProps } from './formSettingsData';

// Form settings › Automatic reply (spec 713:6606)
const AutoReply: React.FC<TabProps> = ({ form, setForm }) =>
    <section className="card">
        <div className="section-title">
            <span className="icon-tile"><FiSend /></span>
            <div className="text">
                <h2>Automatic reply</h2>
                <div className="hint">Sent to the person straight after they submit the form</div>
            </div>
            <Toggle label="Send an automatic reply" checked={form.autoReply} onChange={autoReply => setForm(f => ({ ...f, autoReply }))} />
        </div>

        <div className="field">
            <label className="label" htmlFor="hub-fs-reply">Message</label>
            <textarea id="hub-fs-reply" className="hub-fs-reply" rows={6} value={form.autoReplyMessage} disabled={!form.autoReply}
                onChange={e => { const autoReplyMessage = e.target.value; setForm(f => ({ ...f, autoReplyMessage })); }} />
        </div>

        <TemplateCard off={!form.autoReply} intro="The automatic reply is a template, so it can carry your logo, colours and footer like any other Investi email."
            name="Contact form auto-reply" button="Edit the Template" />
    </section>;

export default AutoReply;
